import { displayNotification, generateOptionsFromData, sendAPIRequest } from 'helpers';
import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import TextFieldCustom from 'components/TextFieldCustom';
import { Box, Checkbox, Divider, IconButton, Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AutoCompleteDropdown from 'components/autocomplete/AutoCompleteDropdown';
import FormControlLabelCustom from 'components/FormControlLabelCustom';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '1000px',
    height: '500px',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    overflowY: 'auto',
    padding: 0,
};
const AddNewPartnerTechModal = ({ open = false, handleClose, id = null, reloadData }) => {
    const { t } = useTranslation();
    const [countries, setCountries] = useState([]);
    const [isregionSelected, setIsregionSelected] = useState(false);
    const [regions, setRegions] = useState([]);
    const initialForm = {
        partner_tech_name: "",
        country_id: [],
        region_id: [],
    };
    const [form, setForm] = useState(initialForm);

    useEffect(() => {
        loadRegions();

    }, []);
    useEffect(() => {
        loadCountries();
    }, [form.region_id, isregionSelected]);
    useEffect(() => {
        if (id) {
            getDataById();
        }
    }, [id]);
    const loadCountries = async () => {
        try {
            let req = isregionSelected
                ? await sendAPIRequest(`/api/country?region_id=${form.region_id}`)
                : await sendAPIRequest(`/api/country`);
            const res = await req.json();
            if (res.success) {
                setCountries(res.data);
            }
        } catch (e) {
            console.log(e);
        }
    };
    const loadRegions = async () => {
        try {
            const req = await sendAPIRequest(`/api/regions`);
            const res = await req.json();
            if (res.success) {
                setRegions(res.data);
            }
        } catch (e) {
            console.log(e);
        }
    };
    const getDataById = async () => {
        try {
            const req = await sendAPIRequest(`/api/partner-tech/${id}`);
            const res = await req.json();
            if (res.success) {
                let temp = {
                    partner_tech_name: res.data.partner_tech_name,
                    country_id: res.data.relationPartnerTechAndCountry.map(x => { return { id: x?.relationCountryAndPartnerTechMapping.id, name: x?.relationCountryAndPartnerTechMapping.country_complete_name } }),
                };
                setForm(temp);
            } else {
                displayNotification('error', `${t("222", "Error loading data")} [B]`);
            }
        } catch (e) {
            console.log(e);
            displayNotification('error', `${t("222", "Error loading data")} [F]`);
        }
    };
    const navigationFunction = (key, value) => {
        let params = { ...form };

        if (key === "country_id") {
            let c = value?.map((y) => {
                return {
                    id: y.value,
                    name: y.label
                }
            });
            params[key] = [...c]
        } else {
            params[key] = value;
        }

        setForm({
            ...params,
        });
    }
    const handleSave = async () => {
        const successKeyword = id ? t("216", "created") : t("217", "saved");
        const errorKeyword = id ? t("218", "creating") : t("219", "saving");

        try {

            if (form.partner_tech_name === "" || form.country_id < 1) {
                displayNotification("warning", "Please fill all fields");
                return;
            }
            const formData = new FormData();
            formData.append('partner_tech_name', form.partner_tech_name);
            if (Array.isArray(form.country_id)) {
                form.country_id.forEach(country => {
                    formData.append('country_id', country.id);
                });
            }
            const req = await sendAPIRequest(
                id
                    ? `/api/partner-tech/${id}`
                    : `/api/partner-tech`,
                id ? "PUT" : "POST",
                formData
            );
            const res = await req.json();
            if (res.success) {
                setForm(initialForm)
                reloadData()
                displayNotification("success", `Successfully ${successKeyword} element`);
                handleClose(false)
            } else {
                displayNotification("error", `Error ${errorKeyword} element [B]`);
            }

        } catch (e) {
            console.log(e);
            displayNotification("error", `Error ${errorKeyword} element [F]`);
        }
    };
    const countryOptions = useMemo(() => {
        return generateOptionsFromData(countries, {
            value: "id",
            label: "country_complete_name",
        });
    }, [countries]);
    const regionOptions = useMemo(() => {
        return generateOptionsFromData(regions, {
            value: "id",
            label: "region_name",
        });
    }, [regions]);
    return (
        <Modal
            open={open}
            onClose={() => handleClose(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Box sx={{ padding: '10px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        {
                            id ? t("-1", "Edit ") : t("-1", "Add New ")
                        }
                        Technical Partners Groups
                    </Typography>
                    <IconButton onClick={() => {
                        handleClose(false)
                    }}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Divider sx={{ backgroundColor: '#000', margin: '0' }} />
                <Box sx={{ padding: '20px' }}>
                    {
                        // !isregionSelected &&
                        <div className=" mb-2 " >
                            <div className="form-group ">
                                <FormControlLabelCustom
                                    control={
                                        <Checkbox
                                            checked={isregionSelected}
                                            onChange={(e) =>
                                                setIsregionSelected(e.target.checked)
                                            }
                                        />
                                    }
                                    label="Filter countries based on regions"
                                />
                            </div>
                        </div>
                    }
                    <div className="row">
                        <div className={`mb-2 mt-2 ${isregionSelected ? "col-4" : "col-6"}`}>
                            <div className="form-group">
                                <TextFieldCustom
                                    type="text"
                                    required={true}
                                    className="form-control"
                                    label={t("-1", "Name")}
                                    value={form.partner_tech_name}
                                    onChange={(e) => setForm({ ...form, partner_tech_name: e.target.value })}
                                    fullWidth
                                    size="medium"
                                />
                            </div>
                        </div>
                        {
                            isregionSelected &&
                            <div className="col-4  mb-2">
                                <div className="form-group">
                                    <AutoCompleteDropdown
                                        type="text"
                                        showClearIcon={true}
                                        error={false}
                                        multiple={true}
                                        label={`Region`}
                                        hasselectall={true}
                                        className="form-control"
                                        options={regionOptions}
                                        getOptionLabel={(option) => option.label}

                                        onChange={(event, value) => {

                                            if (value.some((v) => v.value == "Select all")) {
                                                if (form.region_id.length == regionOptions.length) {
                                                    navigationFunction("region_id", []);
                                                } else {
                                                    navigationFunction("region_id", regionOptions.map((r) => r.value));

                                                }
                                            } else {
                                                navigationFunction("region_id", value.map((r) => r.value));
                                            }
                                        }

                                        }
                                        value={
                                            form.region_id
                                        }
                                        fullWidth
                                        size="medium"
                                    />
                                </div>
                            </div>
                        }

                        <div className={`mb-2 ${isregionSelected ? "col-4" : "col-6"}`}>
                            <div className="form-group">
                                <AutoCompleteDropdown
                                    type="text"
                                    showClearIcon={true}
                                    error={false}
                                    required={true}
                                    multiple={true}
                                    label={`Country`}
                                    hasselectall={true}
                                    className="form-control"
                                    options={countryOptions}
                                    getOptionLabel={(option) => option.label}

                                    onChange={(event, value) => {

                                        if (value.some((v) => v.value == "Select all")) {
                                            if (form.country_id.length == countryOptions.length) {
                                                navigationFunction("country_id", []);
                                            } else {
                                                navigationFunction("country_id", countryOptions.map((r) => r));

                                            }
                                        } else {
                                            navigationFunction("country_id", value.map((r) => r));

                                        }
                                    }

                                    }
                                    value={
                                        form.country_id.map((r) => r.id)
                                    }
                                    fullWidth
                                    size="medium"
                                />
                            </div>
                        </div>

                    </div>


                    <div className="d-flex mt-4 flex-wrap">
                        {
                            form && form.country_id.length > 0 ? (
                                form.country_id.map((country, index) => {
                                    const styles = {
                                        1: { backgroundColor: "#FAE4E8", color: "#B54550" },
                                        2: { backgroundColor: "#E5F4F8", color: "#3B7E94" },
                                        3: { backgroundColor: "#E2EAF7", color: "#2F5AA2" },
                                    };
                                    const style = styles[(index % 3) + 1];
                                    return (
                                        <span
                                            key={index}
                                            style={style}
                                            className="badge fs-5 my-2 p-3 me-3"
                                        >
                                            {/* {group.dashboards_group?.group_name} */}
                                            {country.name}


                                        </span>
                                    );
                                })
                            ) : (
                                null
                            )
                        }

                    </div>

                    <div className='row pt-10'>
                        <div className="col-12 text-center mt-3">
                            <button
                                className="btn btn--outline font-custom fs-6 me-2"
                                onClick={() => {
                                    handleClose(false)
                                }}
                            >
                                {t("-1", "Close")}
                            </button>
                            <button
                                className="btn btn--primary font-custom fs-6"
                                onClick={handleSave}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </Box>
            </Box>
        </Modal>
    );
};



export default AddNewPartnerTechModal;